var map = {
	"./close.svg": "8b1b",
	"./cv.svg": "4042",
	"./facebook.svg": "8485",
	"./github.svg": "14f6",
	"./left-arrow.svg": "6d4b",
	"./linkedin.svg": "9ed9",
	"./mail.svg": "3ae9",
	"./right-arrow.svg": "c686"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";